import { ChevronUpDownIcon, PlusIcon, SettingsIcon } from "@/components/icons";
import { authStore } from "@/store/auth";
import { useSnapshot } from "valtio";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { House, LogOut, User } from "lucide-react";


import IconButton from "@/components/buttons/IconButton";
import Divider from "@/components/Divider";
import DropdownMenu, { MenuItemProp } from "@/components/navigation/DropdownMenu";
import AvatarCard from "@/components/AvatarCard";
import NotificationsMenu from "@/components/navigation/NotificationsMenu";
import UserAvatar from "@/components/navigation/UserAvatar";




const Topbar = () => {
    const auth = useSnapshot(authStore);
    const user = auth.getUser();
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname.replace(/\//g, " ").trim()

    // Same teardown the sidebar's Logout does: clear the stored token and user,
    // then replace the history entry so Back cannot return to the app shell.
    const logout = () => {
        auth.logout();
        navigate("/auth/login", { replace: true });
    }

    const menus: MenuItemProp[] = [
        {
            name: "View Profile",
            link: "/settings",
            icon: <User className="size-5 text-gray-400" />,
        },
        {
            name: "Company Profile",
            link: "/settings/business",
            icon: <House className="size-5 text-gray-400" />
        },
        {
            name: "Logout",
            onClick: logout,
            icon: <LogOut className="size-5 text-gray-400" />
        },
    ]
    return (
        <div className="bg-white flex items-center justify-between py-2 px-6 shadow-sm">
            <h4 className="text-secondary text-lg font-bold capitalize">
                {path}
            </h4>

            <div className="flex items-center space-x-4">
                <Divider axis={"y"} className="h-7" />

                <div className="flex items-center space-x-4">
                    {/*
                        The one thing an applicant can create from anywhere. A complaint is
                        raised through the modal on /complaints and has no route of its own,
                        so it is not offered here — the button navigates rather than opening
                        a menu of one.
                    */}
                    <Link to="/applications/apply" aria-label="New licence application">
                        <IconButton intent="secondary" title="New licence application">
                            <PlusIcon className="size-6" />
                        </IconButton>
                    </Link>

                    <NotificationsMenu />

                    <Link to="/settings" aria-label="Settings">
                        <IconButton intent="secondary" title="Settings">
                            <SettingsIcon className="size-5" />
                        </IconButton>
                    </Link>

                </div>

                <Divider axis={"y"} className="h-7" />

                <DropdownMenu menus={menus}>
                    <AvatarCard
                        title={`${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim()}
                        subTitle={user?.email}
                        leading={(
                            <UserAvatar user={user} />
                        )}
                        trailing={(
                            <ChevronUpDownIcon className="size-5" />
                        )}
                    />
                </DropdownMenu>
            </div>
        </div>
    )
}

export default Topbar
